<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import {getWxConfig} from './utils/ajaxInterface'
export default {
  name: 'App',
  created () {
    getWxConfig(true, {title: '以光为引 点亮归途', desc: '中国民航大学校友会', imgUrl: 'http://cauc-anniversary.oss-cn-zhangjiakou.aliyuncs.com/static/20250922182041_2.png'})
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333333;
  background-color: #f9f9f9;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue